module.exports = "<br>\n<h2 class=\"text-center display-2\">{{przystanek.name}}</h2><br>\n<h1 class=\"text-center display-4\">Przystanek {{index}}</h1>\n<hr>\n<div *ngFor=\"let linia of linesService.linieAutobusowe\">\n    <div *ngFor=\"let przys of linia.przystanki\" id= \"styl\">\n      <div *ngIf=\"przys == index\" id=\"linie\">\n          <a routerLink=\"/lines/{{linia.id}}\"><h2 class=\"text-center display-4\">{{linia.id}}</h2></a>\n      </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stops/details-stop/details-stop.component.html
// module id = ./src/app/stops/details-stop/details-stop.component.html
// module chunks = main